// extracted by mini-css-extract-plugin
export var audioPlayer = "_pa-0";